<script setup lang="ts">
import { useData } from 'vike-vue/useData'
import type { ProductHubPageData } from './+data'

const data = useData<ProductHubPageData>()
</script>

<template>
  <CommonPagesProductHub
    :data="data"
    display-breadcrumb
  />
</template>
